import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import ContactForm from '../components/ContactForm'

export default function ServiceDetail() {
  const { slug } = useParams()
  const [pageData, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    // Fetch page content from CMS
    fetch(`https://api.dev.auxo.dk/public/by-slug/da/${slug}`)
      .then(res => {
        if (res.status === 404) {
          setPage(null)
          setLoading(false)
          return null
        }
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        return res.json()
      })
      .then(data => {
        if (data && data.title && data.content) {
          setPage(data)
          document.title = `${data.title}`
          const metaDesc = document.querySelector('meta[name="description"]')
          if (metaDesc && data.meta_description) {
            metaDesc.setAttribute('content', data.meta_description)
          }
        } else if (data !== null) {
          setPage(null)
        }
        setLoading(false)
      })
      .catch(err => {
        console.warn(`Could not load service page (${slug}):`, err)
        setPage(null)
        setLoading(false)
      })
  }, [slug])

  return (
    <div className="min-h-screen bg-gray-50 py-12 md:py-20 text-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumbs */}
        <div className="text-xs text-gray-500 uppercase tracking-wider mb-6 flex items-center gap-2">
          <Link to="/" className="hover:text-gray-900">Forside</Link>
          <i className="fa-solid fa-chevron-right text-[8px]"></i>
          <span>Services</span>
          <i className="fa-solid fa-chevron-right text-[8px]"></i>
          <span className="text-[#5cbe4f] font-semibold">{pageData?.title?.split('|')[0]?.trim() || 'Service'}</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Left: Service Content */}
          <div className="lg:col-span-7 bg-white p-6 sm:p-10 rounded-2xl border border-gray-200 shadow-sm space-y-8">
            {loading ? (
              <div className="space-y-4 animate-pulse">
                <div className="h-8 bg-gray-200 rounded w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </div>
            ) : pageData?.title && pageData?.content ? (
              <article className="space-y-6">
                <h1 className="text-3xl sm:text-4xl font-black text-gray-950 tracking-tight">
                  {pageData.title.split('|')[0].trim()}
                </h1>
                <div className="h-1 w-20 bg-[#5cbe4f] rounded mb-6"></div>
                
                <div 
                  className="rich-text"
                  dangerouslySetInnerHTML={{ 
                    __html: pageData.content.replace(/<h1[^>]*>.*?<\/h1>/i, '') 
                  }}
                />
              </article>
            ) : (
              <div className="text-center py-12">
                <h2 className="text-xl font-bold text-gray-900 mb-2">Service ikke fundet</h2>
                <p className="text-gray-500">Kunne ikke indlæse den ønskede service. Gå tilbage til <Link to="/" className="text-[#5cbe4f] font-semibold hover:underline">forsiden</Link>.</p>
              </div>
            )}
          </div>

          {/* Right: Contact Form */}
          <div className="lg:col-span-5">
            <ContactForm subject={`Henvendelse vedr. ${pageData?.title?.split('|')[0]?.trim() || 'Service'}`} />
          </div>
        </div>
      </div>
    </div>
  )
}
